// import React, { useState } from 'react';
// import { Plus, Edit, Trash2, Megaphone, Calendar as CalendarIcon } from 'lucide-react';
// import { PageHeader } from '@/components/shared/PageHeader';
// import { StatusBadge } from '@/components/shared/StatusBadge';
// import { ConfirmDialog } from '@/components/shared/ConfirmDialog';
// import { Button } from '@/components/ui/button';
// import { Input } from '@/components/ui/input';
// import { Textarea } from '@/components/ui/textarea';
// import { Card, CardContent } from '@/components/ui/card';
// import { Badge } from '@/components/ui/badge';
// import { Switch } from '@/components/ui/switch';
// import { Label } from '@/components/ui/label';
// import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
// import { Calendar } from '@/components/ui/calendar';
// import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
// import { Separator } from '@/components/ui/separator';
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableHeader,
//   TableRow,
// } from '@/components/ui/table';
// import {
//   Sheet,
//   SheetContent,
//   SheetHeader,
//   SheetTitle,
// } from '@/components/ui/sheet';
// import { format } from 'date-fns';
// import { mockAnnouncements } from '@/data/mock';
// import { toast } from 'sonner';
// import {createAnnouncement} from '@/services/announcementApi'
// const COLOR_OPTIONS = [
//   { value: 'blue', label: 'Blue', class: 'bg-blue-500' },
//   { value: 'green', label: 'Green', class: 'bg-emerald-500' },
//   { value: 'amber', label: 'Amber', class: 'bg-amber-500' },
//   { value: 'red', label: 'Red', class: 'bg-red-500' },
//   { value: 'purple', label: 'Purple', class: 'bg-purple-500' },
// ];

// export const AnnouncementsPage = () => {
//   const [announcements, setAnnouncements] = useState(mockAnnouncements);
//   const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
//   const [isAddingNew, setIsAddingNew] = useState(false);
//   const [deleteAnnouncement, setDeleteAnnouncement] = useState(null);
//   const [startDate, setStartDate] = useState(new Date());
//   const [endDate, setEndDate] = useState(new Date());
//   const [startTime, setStartTime] = useState('00:00');
//   const [endTime, setEndTime] = useState('23:59');
//   const [showLive, setShowLive] = useState(false);
//   const [viewNowEnabled, setViewNowEnabled] = useState(false);
//   const [viewNowLink, setViewNowLink] = useState('');
//   const [watchNowEnabled, setWatchNowEnabled] = useState(false);
//   const [watchNowLink, setWatchNowLink] = useState('');

//   return (
//     <div>
//       <PageHeader
//         title="Announcements"
//         description="Manage site-wide notification bar messages"
//         breadcrumbs={['Admin', 'System', 'Announcements']}
//         actions={
//           <Button onClick={() => setIsAddingNew(true)}>
//             <Plus className="h-4 w-4 mr-2" />
//             Add Announcement
//           </Button>
//         }
//       />

//       <Card className="rounded-xl border-slate-200 shadow-sm">
//         <CardContent className="p-6">
//           <div className="rounded-lg border border-slate-200 overflow-hidden">
//             <Table>
//               <TableHeader>
//                 <TableRow className="bg-slate-50">
//                   <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">Message</TableHead>
//                   <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">Schedule</TableHead>
//                   <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">Display</TableHead>
//                   <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">Status</TableHead>
//                   <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">Priority</TableHead>
//                   <TableHead className="w-12"></TableHead>
//                 </TableRow>
//               </TableHeader>
//               <TableBody>
//                 {announcements.map((announcement) => (
//                   <TableRow key={announcement.id} className="hover:bg-slate-50">
//                     <TableCell>
//                       <div className="flex items-center gap-2">
//                         <div
//                           className={`h-3 w-3 rounded-full ${COLOR_OPTIONS.find(c => c.value === announcement.color)?.class}`}
//                         />
//                         <span className="text-sm text-slate-900 max-w-md truncate">
//                           {announcement.message}
//                         </span>
//                       </div>
//                     </TableCell>
//                     <TableCell>
//                       <div className="text-xs text-slate-600">
//                         <div>{format(new Date(announcement.startDate), 'MMM dd, yyyy')}</div>
//                         <div>to {format(new Date(announcement.endDate), 'MMM dd, yyyy')}</div>
//                       </div>
//                     </TableCell>
//                     <TableCell>
//                       <span className="text-sm text-slate-600">{announcement.displayDuration}s</span>
//                     </TableCell>
//                     <TableCell>
//                       <StatusBadge status={announcement.status} />
//                     </TableCell>
//                     <TableCell>
//                       <Badge variant="outline">{announcement.priority}</Badge>
//                     </TableCell>
//                     <TableCell>
//                       <div className="flex gap-1">
//                         <Button
//                           variant="ghost"
//                           size="icon"
//                           className="h-8 w-8"
//                           onClick={() => setSelectedAnnouncement(announcement)}
//                         >
//                           <Edit className="h-4 w-4" />
//                         </Button>
//                         <Button
//                           variant="ghost"
//                           size="icon"
//                           className="h-8 w-8 text-red-600"
//                           onClick={() => setDeleteAnnouncement(announcement)}
//                         >
//                           <Trash2 className="h-4 w-4" />
//                         </Button>
//                       </div>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </div>
//         </CardContent>
//       </Card>

//       <Sheet open={isAddingNew || !!selectedAnnouncement} onOpenChange={(open) => { if (!open) { setIsAddingNew(false); setSelectedAnnouncement(null); }}}>
//         <SheetContent className="w-[500px] overflow-y-auto">
//           <SheetHeader>
//             <SheetTitle>{isAddingNew ? 'Add Announcement' : 'Edit Announcement'}</SheetTitle>
//           </SheetHeader>
//           <div className="mt-6 space-y-6">
//             <div>
//               <Label>Message</Label>
//               <Textarea
//                 placeholder="Enter announcement message..."
//                 className="mt-2"
//                 rows={3}
//                 defaultValue={selectedAnnouncement?.message}
//               />
//             </div>
//             <div>
//               <Label>Link URL (optional)</Label>
//               <Input
//                 placeholder="https://..."
//                 className="mt-2"
//                 defaultValue={selectedAnnouncement?.linkUrl}
//               />
//             </div>
//             <div>
//               <Label>Color</Label>
//               <RadioGroup defaultValue={selectedAnnouncement?.color || 'blue'} className="mt-2">
//                 <div className="flex flex-wrap gap-3">
//                   {COLOR_OPTIONS.map((color) => (
//                     <div key={color.value} className="flex items-center space-x-2">
//                       <RadioGroupItem value={color.value} id={color.value} />
//                       <Label htmlFor={color.value} className="flex items-center gap-2 cursor-pointer">
//                         <div className={`h-4 w-4 rounded-full ${color.class}`} />
//                         {color.label}
//                       </Label>
//                     </div>
//                   ))}
//                 </div>
//               </RadioGroup>
//             </div>
            
//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <Label>Start Date & Time</Label>
//                 <Popover>
//                   <PopoverTrigger asChild>
//                     <Button
//                       variant="outline"
//                       className="w-full justify-start text-left font-normal mt-2"
//                     >
//                       <CalendarIcon className="mr-2 h-4 w-4" />
//                       {startDate ? format(startDate, 'PPP') : <span>Pick a date</span>}
//                     </Button>
//                   </PopoverTrigger>
//                   <PopoverContent className="w-auto p-0">
//                     <Calendar
//                       mode="single"
//                       selected={startDate}
//                       onSelect={setStartDate}
//                       initialFocus
//                     />
//                   </PopoverContent>
//                 </Popover>
//                 <Input
//                   type="time"
//                   value={startTime}
//                   onChange={(e) => setStartTime(e.target.value)}
//                   className="mt-2"
//                 />
//               </div>
//               <div>
//                 <Label>End Date & Time</Label>
//                 <Popover>
//                   <PopoverTrigger asChild>
//                     <Button
//                       variant="outline"
//                       className="w-full justify-start text-left font-normal mt-2"
//                     >
//                       <CalendarIcon className="mr-2 h-4 w-4" />
//                       {endDate ? format(endDate, 'PPP') : <span>Pick a date</span>}
//                     </Button>
//                   </PopoverTrigger>
//                   <PopoverContent className="w-auto p-0">
//                     <Calendar
//                       mode="single"
//                       selected={endDate}
//                       onSelect={setEndDate}
//                       initialFocus
//                     />
//                   </PopoverContent>
//                 </Popover>
//                 <Input
//                   type="time"
//                   value={endTime}
//                   onChange={(e) => setEndTime(e.target.value)}
//                   className="mt-2"
//                 />
//               </div>
//             </div>
            
//             <div className="grid grid-cols-2 gap-4">
//               <div>
//                 <Label>Display Duration (seconds)</Label>
//                 <Input
//                   type="number"
//                   placeholder="8"
//                   className="mt-2"
//                   defaultValue={selectedAnnouncement?.displayDuration}
//                 />
//               </div>
//               <div>
//                 <Label>Priority</Label>
//                 <Input
//                   type="number"
//                   placeholder="1"
//                   className="mt-2"
//                   defaultValue={selectedAnnouncement?.priority}
//                 />
//               </div>
//             </div>
            
//             <Separator className="my-4" />
            
//             <div className="space-y-4">
//               <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
//                 <div>
//                   <Label className="font-medium">Show LIVE Badge</Label>
//                   <p className="text-xs text-slate-500 mt-1">Display a blinking LIVE indicator at the start of the message</p>
//                 </div>
//                 <Switch 
//                   checked={showLive} 
//                   onCheckedChange={setShowLive} 
//                 />
//               </div>

//               <div className="space-y-3">
//                 <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
//                   <div>
//                     <Label className="font-medium">View Now Button</Label>
//                     <p className="text-xs text-slate-500 mt-1">Add a clickable button at the end of the message</p>
//                   </div>
//                   <Switch 
//                     checked={viewNowEnabled} 
//                     onCheckedChange={setViewNowEnabled} 
//                   />
//                 </div>
//                 {viewNowEnabled && (
//                   <div>
//                     <Label>View Now Link URL</Label>
//                     <Input
//                       type="url"
//                       placeholder="https://example.com/view"
//                       value={viewNowLink}
//                       onChange={(e) => setViewNowLink(e.target.value)}
//                       className="mt-2"
//                     />
//                   </div>
//                 )}
//               </div>

//               <div className="space-y-3">
//                 <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
//                   <div>
//                     <Label className="font-medium">Watch Now Button</Label>
//                     <p className="text-xs text-slate-500 mt-1">Add a clickable button at the end of the message</p>
//                   </div>
//                   <Switch 
//                     checked={watchNowEnabled} 
//                     onCheckedChange={setWatchNowEnabled} 
//                   />
//                 </div>
//                 {watchNowEnabled && (
//                   <div>
//                     <Label>Watch Now Link URL</Label>
//                     <Input
//                       type="url"
//                       placeholder="https://example.com/watch"
//                       value={watchNowLink}
//                       onChange={(e) => setWatchNowLink(e.target.value)}
//                       className="mt-2"
//                     />
//                   </div>
//                 )}
//               </div>
//             </div>

//             <Separator className="my-4" />

//             <div className="flex items-center justify-between">
//               <Label>Dismissible</Label>
//               <Switch defaultChecked={selectedAnnouncement?.dismissible ?? true} />
//             </div>
//             <div className="flex items-center justify-between">
//               <Label>Active</Label>
//               <Switch defaultChecked={selectedAnnouncement?.active ?? true} />
//             </div>

//             {/* Preview */}
//             <div className="mt-6">
//               <Label className="mb-2 block">Preview</Label>
//               <div className="p-4 rounded-lg bg-blue-50 border border-blue-200">
//                 <div className="flex items-center gap-2 flex-wrap">
//                   {showLive && (
//                     <span className="inline-flex items-center gap-1 px-2 py-1 bg-red-600 text-white text-xs font-bold rounded animate-pulse">
//                       <span className="h-2 w-2 bg-white rounded-full animate-ping absolute"></span>
//                       <span className="h-2 w-2 bg-white rounded-full relative"></span>
//                       LIVE
//                     </span>
//                   )}
//                   <span className="text-sm text-slate-700">Your announcement message will appear here...</span>
//                   {viewNowEnabled && (
//                     <button className="ml-auto px-3 py-1 bg-blue-600 text-white text-xs font-medium rounded hover:bg-blue-700">
//                       View Now →
//                     </button>
//                   )}
//                   {watchNowEnabled && (
//                     <button className="ml-auto px-3 py-1 bg-red-600 text-white text-xs font-medium rounded hover:bg-red-700">
//                       Watch Now ▶
//                     </button>
//                   )}
//                 </div>
//               </div>
//             </div>

//             <Button
//               className="w-full"
//               onClick={() => {
//                 toast.success('Announcement saved');
//                 setIsAddingNew(false);
//                 setSelectedAnnouncement(null);
//               }}
//             >
//               Save Announcement
//             </Button>
//           </div>
//         </SheetContent>
//       </Sheet>

//       <ConfirmDialog
//         open={!!deleteAnnouncement}
//         onOpenChange={() => setDeleteAnnouncement(null)}
//         title="Delete Announcement"
//         description="Are you sure you want to delete this announcement? It will be removed from the notification bar. This action cannot be undone."
//         confirmLabel="Delete"
//         variant="destructive"
//         onConfirm={() => {
//           setAnnouncements(announcements.filter(a => a.id !== deleteAnnouncement.id));
//           toast.success('Announcement deleted');
//           setDeleteAnnouncement(null);
//         }}
//       />
//     </div>
//   );
// };









import React, { useState, useEffect } from 'react';
import { Plus, Edit, Trash2, Calendar as CalendarIcon, Loader2 } from 'lucide-react';
import { PageHeader } from '@/components/shared/PageHeader';
import { StatusBadge } from '@/components/shared/StatusBadge';
import { ConfirmDialog } from '@/components/shared/ConfirmDialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Calendar } from '@/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Separator } from '@/components/ui/separator';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { format } from 'date-fns';
import { toast } from 'sonner';
import {
  createAnnouncement,
  getAllAnnouncements,
  deleteAnnouncement,
  updateAnnouncement,
} from '@/services/announcementApi';

const COLOR_OPTIONS = [
  { value: 'blue', label: 'Blue', class: 'bg-blue-500' },
  { value: 'green', label: 'Green', class: 'bg-emerald-500' },
  { value: 'amber', label: 'Amber', class: 'bg-amber-500' },
  { value: 'red', label: 'Red', class: 'bg-red-500' },
  { value: 'purple', label: 'Purple', class: 'bg-purple-500' },
];

// Helper: Date + time → ISO string
const toISOString = (date, time) => {
  if (!date) return new Date().toISOString();
  const [hours, minutes] = time.split(':').map(Number);
  const d = new Date(date);
  d.setHours(hours || 0, minutes || 0, 0, 0);
  return d.toISOString();
};

export const AnnouncementsPage = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [deleteAnnouncementItem, setDeleteAnnouncementItem] = useState(null);

  // Form state
  const [message, setMessage] = useState('');
  const [linkUrl, setLinkUrl] = useState('');
  const [color, setColor] = useState('blue');
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [startTime, setStartTime] = useState('00:00');
  const [endTime, setEndTime] = useState('23:59');
  const [displayDuration, setDisplayDuration] = useState(8);
  const [priority, setPriority] = useState(1);
  const [showLive, setShowLive] = useState(false);
  const [viewNowEnabled, setViewNowEnabled] = useState(false);
  const [viewNowLink, setViewNowLink] = useState('');
  const [watchNowEnabled, setWatchNowEnabled] = useState(false);
  const [watchNowLink, setWatchNowLink] = useState('');
  const [dismissible, setDismissible] = useState(true);
  const [isActive, setIsActive] = useState(true);

  // ==================== FETCH ALL ====================
  const fetchAnnouncements = async () => {
    try {
      setLoading(true);
      const data = await getAllAnnouncements();
      // Handle both array and { data: [...] } response
      setAnnouncements(Array.isArray(data) ? data : data?.data || []);
    } catch (error) {
      console.error(error);
      toast.error('Failed to load announcements');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  // ==================== FORM HELPERS ====================
  const resetForm = () => {
    setMessage('');
    setLinkUrl('');
    setColor('blue');
    setStartDate(new Date());
    setEndDate(new Date());
    setStartTime('00:00');
    setEndTime('23:59');
    setDisplayDuration(8);
    setPriority(1);
    setShowLive(false);
    setViewNowEnabled(false);
    setViewNowLink('');
    setWatchNowEnabled(false);
    setWatchNowLink('');
    setDismissible(true);
    setIsActive(true);
  };

  const openCreate = () => {
    resetForm();
    setIsAddingNew(true);
    setSelectedAnnouncement(null);
  };

  const openEdit = (ann) => {
    setSelectedAnnouncement(ann);
    setIsAddingNew(false);

    setMessage(ann.message || '');
    setLinkUrl(ann.link_url || ann.linkUrl || '');
    setColor(ann.color || 'blue');

    const start = new Date(ann.start_at || ann.startDate);
    const end = new Date(ann.end_at || ann.endDate);
    setStartDate(start);
    setEndDate(end);
    setStartTime(format(start, 'HH:mm'));
    setEndTime(format(end, 'HH:mm'));

    setDisplayDuration(ann.display_duration ?? ann.displayDuration ?? 8);
    setPriority(ann.priority ?? 1);
    setShowLive(!!(ann.show_live_badge ?? ann.showLive));
    setViewNowEnabled(!!(ann.show_view_now ?? ann.viewNowEnabled));
    setViewNowLink(ann.view_now_link || ann.viewNowLink || '');
    setWatchNowEnabled(!!(ann.show_watch_now ?? ann.watchNowEnabled));
    setWatchNowLink(ann.watch_now_link || ann.watchNowLink || '');
    setDismissible(ann.dismissible ?? true);
    setIsActive(ann.is_active ?? ann.active ?? true);
  };

  const closeSheet = () => {
    setIsAddingNew(false);
    setSelectedAnnouncement(null);
    resetForm();
  };

  // ==================== BUILD PAYLOAD ====================
  const buildPayload = (includeId = false) => {
  const payload = {
    message,
    link_url: linkUrl || '',
    color,
    start_at: toISOString(startDate, startTime),
    end_at: toISOString(endDate, endTime),
    display_duration: Number(displayDuration) || 0,
    priority: Number(priority) || 1,
    show_live_badge: showLive,
    show_view_now: viewNowEnabled,
    show_watch_now: watchNowEnabled,
    dismissible,
    is_active: isActive,
  };

  if (includeId && selectedAnnouncement?.id) {
    payload.id = selectedAnnouncement.id;
  }

  return payload;
};

const handleSave = async () => {
  if (!message.trim()) {
    toast.error('Message is required');
    return;
  }

  setSaving(true);

  try {
    if (isAddingNew) {
      await createAnnouncement(buildPayload(false));
      toast.success('Announcement created successfully');
    } else {
      // { id, message, link_url, color, start_at, end_at, ... }
      await updateAnnouncement(buildPayload(true));
      toast.success('Announcement updated successfully');
    }

    closeSheet();
    fetchAnnouncements();
  } catch (error) {
    console.error(error);
    toast.error(
      error?.response?.data?.message || 'Failed to save announcement'
    );
  } finally {
    setSaving(false);
  }
};
  // ==================== DELETE ====================
  const handleDelete = async () => {
    if (!deleteAnnouncementItem) return;

    try {
      await deleteAnnouncement(deleteAnnouncementItem.id);
      toast.success('Announcement deleted');
      setDeleteAnnouncementItem(null);
      fetchAnnouncements();
    } catch (error) {
      console.error(error);
      toast.error('Failed to delete announcement');
    }
  };

  return (
    <div>
      <PageHeader
        title="Announcements"
        description="Manage site-wide notification bar messages"
        breadcrumbs={['Admin', 'System', 'Announcements']}
        actions={
          <Button onClick={openCreate}>
            <Plus className="h-4 w-4 mr-2" />
            Add Announcement
          </Button>
        }
      />

      <Card className="rounded-xl border-slate-200 shadow-sm">
        <CardContent className="p-6">
          {loading ? (
            <div className="flex items-center justify-center py-20">
              <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
            </div>
          ) : (
            <div className="rounded-lg border border-slate-200 overflow-hidden">
              <Table>
                <TableHeader>
                  <TableRow className="bg-slate-50">
                    <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                      Message
                    </TableHead>
                    <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                      Schedule
                    </TableHead>
                    <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                      Display
                    </TableHead>
                    <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                      Status
                    </TableHead>
                    <TableHead className="text-xs font-semibold uppercase tracking-wider text-slate-500">
                      Priority
                    </TableHead>
                    <TableHead className="w-12"></TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {announcements.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} className="text-center py-12 text-slate-500">
                        No announcements found
                      </TableCell>
                    </TableRow>
                  ) : (
                    announcements.map((announcement) => (
                      <TableRow key={announcement.id} className="hover:bg-slate-50">
                        <TableCell>
                          <div className="flex items-center gap-2">
                            <div
                              className={`h-3 w-3 rounded-full ${
                                COLOR_OPTIONS.find((c) => c.value === announcement.color)?.class ||
                                'bg-slate-400'
                              }`}
                            />
                            <span className="text-sm text-slate-900 max-w-md truncate">
                              {announcement.message}
                            </span>
                          </div>
                        </TableCell>
                        <TableCell>
                          <div className="text-xs text-slate-600">
                            <div>
                              {format(
                                new Date(announcement.start_at || announcement.startDate),
                                'MMM dd, yyyy'
                              )}
                            </div>
                            <div>
                              to{' '}
                              {format(
                                new Date(announcement.end_at || announcement.endDate),
                                'MMM dd, yyyy'
                              )}
                            </div>
                          </div>
                        </TableCell>
                        <TableCell>
                          <span className="text-sm text-slate-600">
                            {announcement.display_duration ?? announcement.displayDuration}s
                          </span>
                        </TableCell>
                        <TableCell>
                          <StatusBadge
                            status={
                              (announcement.is_active ?? announcement.active)
                                ? 'active'
                                : 'inactive'
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <Badge variant="outline">{announcement.priority}</Badge>
                        </TableCell>
                        <TableCell>
                          <div className="flex gap-1">
                            <Button
                              variant="ghost"
                              size="icon"
                              className="h-8 w-8"
                              onClick={() => openEdit(announcement)}
                            >
                              <Edit className="h-4 w-4" />
                            </Button>
                            <Button
                              variant="ghost"
                              size="icon"
                              className="h-8 w-8 text-red-600"
                              onClick={() => setDeleteAnnouncementItem(announcement)}
                            >
                              <Trash2 className="h-4 w-4" />
                            </Button>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>

      {/* ==================== SHEET ==================== */}
      <Sheet
        open={isAddingNew || !!selectedAnnouncement}
        onOpenChange={(open) => {
          if (!open) closeSheet();
        }}
      >
        <SheetContent className="w-[500px] overflow-y-auto">
          <SheetHeader>
            <SheetTitle>
              {isAddingNew ? 'Add Announcement' : 'Edit Announcement'}
            </SheetTitle>
          </SheetHeader>

          <div className="mt-6 space-y-6">
            {/* Message */}
            <div>
              <Label>Message</Label>
              <Textarea
                placeholder="Enter announcement message..."
                className="mt-2"
                rows={3}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>

            {/* Link URL */}
            <div>
              <Label>Link URL (optional)</Label>
              <Input
                placeholder="https://..."
                className="mt-2"
                value={linkUrl}
                onChange={(e) => setLinkUrl(e.target.value)}
              />
            </div>

            {/* Color */}
            <div>
              <Label>Color</Label>
              <RadioGroup value={color} onValueChange={setColor} className="mt-2">
                <div className="flex flex-wrap gap-3">
                  {COLOR_OPTIONS.map((c) => (
                    <div key={c.value} className="flex items-center space-x-2">
                      <RadioGroupItem value={c.value} id={c.value} />
                      <Label htmlFor={c.value} className="flex items-center gap-2 cursor-pointer">
                        <div className={`h-4 w-4 rounded-full ${c.class}`} />
                        {c.label}
                      </Label>
                    </div>
                  ))}
                </div>
              </RadioGroup>
            </div>

            {/* Dates */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Start Date & Time</Label>
                <Popover>
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      className="w-full justify-start text-left font-normal mt-2"
                    >
                      <CalendarIcon className="mr-2 h-4 w-4" />
                      {startDate ? format(startDate, "MMM/dd/yyyy") : <span>Pick a date</span>}
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0">
                    <Calendar
                      mode="single"
                      selected={startDate}
                      onSelect={(d) => d && setStartDate(d)}
                      initialFocus
                    />
                  </PopoverContent>
                </Popover>
                <Input
                  type="time"
                  value={startTime}
                  onChange={(e) => setStartTime(e.target.value)}
                  className="mt-2"
                />
              </div>

              <div>
                <Label>End Date & Time</Label>
                <Popover>
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      className="w-fit justify-start text-left font-normal mt-2 mr-2"
                    >
                      <CalendarIcon className="mr-2 h-4 w-4" />
                      {endDate ? format(endDate, "MMM/dd/yyyy") : <span>Pick a date</span>}
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent className="w-auto p-0">
                    <Calendar
                      mode="single"
                      selected={endDate}
                      onSelect={(d) => d && setEndDate(d)}
                      initialFocus
                    />
                  </PopoverContent>
                </Popover>
                <Input
                  type="time"
                  value={endTime}
                  onChange={(e) => setEndTime(e.target.value)}
                  className="mt-2"
                />
              </div>
            </div>

            {/* Duration + Priority */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>Display Duration (seconds)</Label>
                <Input
                  type="number"
                  className="mt-2"
                  value={displayDuration}
                  onChange={(e) => setDisplayDuration(Number(e.target.value))}
                />
              </div>
              <div>
                <Label>Priority</Label>
                <Input
                  type="number"
                  className="mt-2"
                  value={priority}
                  onChange={(e) => setPriority(Number(e.target.value))}
                />
              </div>
            </div>

            <Separator className="my-4" />

            {/* Toggles */}
            <div className="space-y-4">
              <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                <div>
                  <Label className="font-medium">Show LIVE Badge</Label>
                  <p className="text-xs text-slate-500 mt-1">
                    Display a blinking LIVE indicator
                  </p>
                </div>
                <Switch checked={showLive} onCheckedChange={setShowLive} />
              </div>

              <div className="space-y-3">
                <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                  <div>
                    <Label className="font-medium">View Now Button</Label>
                    <p className="text-xs text-slate-500 mt-1">
                      Add a clickable button at the end of the message
                    </p>
                  </div>
                  <Switch checked={viewNowEnabled} onCheckedChange={setViewNowEnabled} />
                </div>
                {viewNowEnabled && (
                  <div>
                    <Label>View Now Link URL</Label>
                    <Input
                      type="url"
                      placeholder="https://example.com/view"
                      value={viewNowLink}
                      onChange={(e) => setViewNowLink(e.target.value)}
                      className="mt-2"
                    />
                  </div>
                )}
              </div>

              <div className="space-y-3">
                <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                  <div>
                    <Label className="font-medium">Watch Now Button</Label>
                    <p className="text-xs text-slate-500 mt-1">
                      Add a clickable button at the end of the message
                    </p>
                  </div>
                  <Switch checked={watchNowEnabled} onCheckedChange={setWatchNowEnabled} />
                </div>
                {watchNowEnabled && (
                  <div>
                    <Label>Watch Now Link URL</Label>
                    <Input
                      type="url"
                      placeholder="https://example.com/watch"
                      value={watchNowLink}
                      onChange={(e) => setWatchNowLink(e.target.value)}
                      className="mt-2"
                    />
                  </div>
                )}
              </div>
            </div>

            <Separator className="my-4" />

            <div className="flex items-center justify-between">
              <Label>Dismissible</Label>
              <Switch checked={dismissible} onCheckedChange={setDismissible} />
            </div>

            <div className="flex items-center justify-between">
              <Label>Active</Label>
              <Switch checked={isActive} onCheckedChange={setIsActive} />
            </div>

            {/* Preview */}
            <div className="mt-6">
              <Label className="mb-2 block">Preview</Label>
              <div className="p-4 rounded-lg bg-blue-50 border border-blue-200">
                <div className="flex items-center gap-2 flex-wrap">
                  {showLive && (
                    <span className="relative inline-flex items-center gap-1 px-2 py-1 bg-red-600 text-white text-xs font-bold rounded">
                      <span className="h-2 w-2 bg-white rounded-full animate-ping absolute" />
                      <span className="h-2 w-2 bg-white rounded-full relative" />
                      LIVE
                    </span>
                  )}
                  <span className="text-sm text-slate-700">
                    {message || 'Your announcement message will appear here...'}
                  </span>
                  {viewNowEnabled && (
                    <button className="ml-auto px-3 py-1 bg-blue-600 text-white text-xs font-medium rounded hover:bg-blue-700">
                      View Now →
                    </button>
                  )}
                  {watchNowEnabled && (
                    <button className="ml-auto px-3 py-1 bg-red-600 text-white text-xs font-medium rounded hover:bg-red-700">
                      Watch Now ▶
                    </button>
                  )}
                </div>
              </div>
            </div>

            <Button className="w-full" onClick={handleSave} disabled={saving}>
              {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              {isAddingNew ? 'Create Announcement' : 'Update Announcement'}
            </Button>
          </div>
        </SheetContent>
      </Sheet>

      {/* Delete Confirmation */}
      <ConfirmDialog
        open={!!deleteAnnouncementItem}
        onOpenChange={() => setDeleteAnnouncementItem(null)}
        title="Delete Announcement"
        description="Are you sure you want to delete this announcement? It will be removed from the notification bar. This action cannot be undone."
        confirmLabel="Delete"
        variant="destructive"
        onConfirm={handleDelete}
      />
    </div>
  );
};